import React from 'react';
import _ from 'lodash';
import { Box, Tooltip, Menu, MenuItem, Stack, Typography, Switch, FormControlLabel, Button } from '@mui/material';
import { DebounceInput } from 'react-debounce-input';
import { useSelector, useDispatch } from 'react-redux';
import ListIcon from '@mui/icons-material/List';

import { CssTextField } from '../others/CssTextField';
import { orderColumns } from '../../services/column-definitions';
import { setOrderSearchFields } from '../../services/redux-actions';

export const OrderAdvancedFilter = props => {
  const { searchCallback } = props;
  const { orderSearchFields } = useSelector(state => state.employeeOrderConfig);
  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleChange = field => {
    if (orderSearchFields.includes(field)) {
      dispatch(setOrderSearchFields(_.filter(orderSearchFields, item => item !== field)));
    } else {
      dispatch(setOrderSearchFields([...orderSearchFields, field]));
    }
  };

  return (
    <DebounceInput
      debounceTimeout={1000}
      style={{ width: 150, marginRight: 8 }}
      element={CssTextField}
      placeholder="Wyszukaj..."
      onChange={e => searchCallback(e.target.value)}
      variant="standard"
      InputProps={{
        endAdornment: (
          <>
            <Tooltip title="Kolumny do wyszukiwania">
              <ListIcon sx={{ cursor: 'pointer', color: '#9B231F' }} onClick={handleClick} />
            </Tooltip>
            <Menu
              id="long-menu"
              MenuListProps={{
                'aria-labelledby': 'long-button'
              }}
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
              PaperProps={{
                style: {
                  height: '50ch',
                  width: '34ch'
                }
              }}
            >
              {orderColumns().slice(1)
                .map(option => (
                  <MenuItem key={option.field} value={option.field}>
                    <FormControlLabel control={
                      <Switch
                        size="small"
                        checked={_.find(orderSearchFields, item => item == option.field) ? true : false}
                        onChange={() => handleChange(option.field)}
                      />
                    } label={option.headerName} />
                  </MenuItem>
                ))}
              <Stack direction="row" justifyContent="space-between" sx={{ p: 1 }}>
                <Button><Typography color="primary" onClick={() => dispatch(setOrderSearchFields([]))}>Ukryj wszystko</Typography></Button>
                <Button><Typography color="primary" onClick={() => dispatch(setOrderSearchFields(orderColumns().slice(1)
                  .map(obj => obj.field)))}>Pokaż wszystko</Typography></Button>
              </Stack>
            </Menu>
          </>

        )
      }}
    />
  );
};
